import axios from "axios";
import AspApi from "api/ApiConfig";
import { baseURL } from "api/ApiConfig";

const gxApi = axios.create({
  baseURL: baseURL,
});

// sequence
export const createSequence = async (payload) => {
  const res = await AspApi.post(
    `/api/v1/svc/campaign_sequence/sequences`,
    payload
  );
  return res;
};

export const getSequence = async (seqId, payload) => {
  let qpm = [];
  if (payload?.brandId) qpm.push(`brand_id=${payload?.brandId}`);
  if (payload?.campaignId) qpm.push(`campaign_id=${payload?.campaignId}`);
  if (payload?.flow) qpm.push(`flow=${payload?.flow}`);

  let qpmString = "";
  if (qpm?.length > 0) qpmString = "?" + qpm.join("&");

  const res = await AspApi.get(
    `/api/v1/svc/campaign_sequence/sequences/${seqId}${qpmString}`
  );

  return res;
};

export const updateSequence = async (seqId, payload) => {
  const res = await AspApi.put(
    `/api/v1/svc/campaign_sequence/sequences/${seqId}`,
    payload
  );
  return res;
};

export const changeSequenceStatus = async (seqId, payload) => {
  const res = await AspApi.put(
    `/api/v1/svc/campaign_sequence/sequences/${seqId}/change_state`,
    payload
  );
  return res;
};

export const deleteSequence = async (seqId, brandId, campaignId) => {
  const res = await AspApi.delete(
    `/api/v1/svc/campaign_sequence/sequences/${seqId}?brand_id=${brandId}&campaign_id=${campaignId}`
  );
  return res;
};

// triggers
export const createInitialTrigger = async (seqId, payload) => {
  const res = await AspApi.post(
    `/api/v1/svc/campaign_sequence/sequences/${seqId}/triggers`,
    payload
  );
  return res;
};

export const updateInitialTrigger = async (seqId, triggerId, payload) => {
  const res = await AspApi.put(
    `/api/v1/svc/campaign_sequence/sequences/${seqId}/triggers/${triggerId}`,
    payload
  );
  return res;
};

export const createNewBoroadcast = async (payload) => {
  const res = await AspApi.post(
    `api/v1/svc/campaign_broadcast/broadcasts/quick_create`,
    payload
  );
  return res;
};

export const updateNewBoroadcast = async (broadcastId, payload) => {
  const res = await AspApi.put(
    `api/v1/svc/campaign_broadcast/broadcasts/${broadcastId}`,
    payload
  );
  return res;
};

export const sendWhatsappPreview = async (payload) => {
  const res = await AspApi.post(
    `/api/v1/svc/whatsapp/conversations/send_template`,
    payload
  );
  return res;
};

export const generateQR = async (sequence_id, payload) => {
  const res = await AspApi.post(
    `/api/v1/svc/campaign_sequence/sequences/${sequence_id}/qr_generator`,
    payload
  );
  return res;
};

// nodes
export const createNode = async (seqId, payload) => {
  const res = await AspApi.post(
    `/api/v1/svc/campaign_sequence/sequences/${seqId}/nodes`,
    payload
  );
  return res;
};

export const updateNode = async (seqId, nodeId, payload) => {
  const res = await AspApi.put(
    `/api/v1/svc/campaign_sequence/sequences/${seqId}/nodes/${nodeId}`,
    payload
  );
  return res;
};

export const deleteNode = async (seqId, nodeId, payload) => {
  let qpm = [];
  if (payload?.brandId) qpm.push(`brand_id=${payload?.brandId}`);
  if (payload?.campaignId) qpm.push(`campaign_id=${payload?.campaignId}`);
  if (payload?.nodeType) qpm.push(`node_type=${payload?.nodeType}`);

  let qpmString = "";
  if (qpm?.length > 0) qpmString = "?" + qpm.join("&");

  const res = await AspApi.delete(
    `/api/v1/svc/campaign_sequence/sequences/${seqId}/nodes/${nodeId}${qpmString}`
  );
  return res;
};

export const updateNodeCoordinates = async (seqId, nodeId, payload) => {
  const res = await AspApi.put(
    `/api/v1/svc/campaign_sequence/sequences/${seqId}/nodes/${nodeId}/node_position`,
    payload
  );
  return res;
};

export const updateNodeDefaults = async (seqId, nodeId, payload) => {
  const res = await AspApi.put(
    `/api/v1/svc/campaign_sequence/sequences/${seqId}/nodes/${nodeId}/node_defaults`,
    payload
  );
  return res;
};

// NODE
export const createTextNode = async (seqId, nodeId, payload) => {
  const res = await AspApi.put(
    `/api/v1/svc/campaign_sequence/sequences/${seqId}/nodes/${nodeId}`,
    payload
  );
  return res;
};

export const markAsEndNode = async (seqId, nodeId, payload) => {
  const res = await AspApi.put(
    `/api/v1/svc/campaign_sequence/sequences/${seqId}/nodes/${nodeId}/mark_end`,
    payload
  );
  return res;
};

// EDGES
export const createNewEdge = async (seqId, payload) => {
  const res = await AspApi.post(
    `/api/v1/svc/campaign_sequence/sequences/${seqId}/edges`,
    payload
  );
  return res;
};

export const deleteEdge = async (seqId, edgeId, payload) => {
  let qpm = [];
  if (payload?.brand_id) qpm.push(`brand_id=${payload?.brand_id}`);
  if (payload?.campaign_id) qpm.push(`campaign_id=${payload?.campaign_id}`);

  let qpmString = "";
  if (qpm?.length > 0) qpmString = "?" + qpm.join("&");

  const res = await AspApi.delete(
    `/api/v1/svc/campaign_sequence/sequences/${seqId}/edges/${edgeId}${qpmString}`
  );
  return res;
};

// META ADS

export const getMetaCampaignNames = async (brand_id) => {
  const res = await AspApi.get(
    `/api/v1/svc/facebook/fb_utils/fb_campaigns?brand_id=${brand_id}`
  );
  return res;
};

export const getMetaAds = async (brand_id, fb_campaign_id) => {
  const res = await AspApi.get(
    `/api/v1/svc/facebook/fb_utils/fb_ad_sets?brand_id=${brand_id}&fb_campaign_id=${fb_campaign_id}`
  );
  return res;
};

export const getFbAds = async (brand_id, fb_ad_set_id) => {
  const res = await AspApi.get(
    `/api/v1/svc/facebook/fb_utils/fb_ads?brand_id=${brand_id}&fb_ad_set_id=${fb_ad_set_id}`
  );
  return res;
};

// Attribute List
export const AttributeList = async (brandId, contact_person_id) => {
  let url = `api/v1/svc/contacts/profile_attribute_utils/scopes_and_attributes_list?brand_id=${brandId}`;

  // Only append contact_person_id if it's provided
  if (contact_person_id) {
    url += `&contact_person_id=${contact_person_id}`;
  }

  const res = await AspApi.get(url);
  return res;
};

// trigger_sequence for mobile number

/**
 * Trigger a sequence with the given payload
 * @param {string} seqId - The sequence ID
 * @param {Object} payload - The request payload
 * @returns {Promise<Object>} - The API response
 */
export const triggerSequence = async (seqId, payload, headers) => {
  if (!seqId) throw new Error("Sequence ID is required");
  if (!payload) throw new Error("Payload is required");
  if (!payload?.mobile_number) throw new Error("Mobile number is required");

  const config = headers ? { headers } : {};
  
  const response = await gxApi.post(
    `/api/v1/svc/campaign_sequence/sequences/trigger_sequence/${seqId}`,
    payload,
    config
  );
  return response;
};

export const getSequenceNodeMetrics = async (seqId, nodeId, payload) => {
  let qpm = [];
    if (payload?.brand_id) qpm.push(`brand_id=${payload?.brand_id}`);
    if (payload?.campaign_id) qpm.push(`campaign_id=${payload?.campaign_id}`);
  const response = await AspApi.get(
    `/api/v1/svc/campaign_sequence/sequences/${seqId}/nodes/${nodeId}/node_metrics?${qpm.join("&")}`
  );
  return response;
};

// check_keyword for keyword trigger
export const checkKeyword = async (brandId, payload) => {
    if (!brandId) throw new Error("Brand ID is required");
    if (!payload?.keyword) throw new Error("Keyword is required");

    let qpm = [];
    if (brandId) qpm.push(`brand_id=${brandId}`);
    if (payload?.keyword) qpm.push(`keyword=${payload?.keyword}`);
    if (payload?.match_type) qpm.push(`match_type=${payload?.match_type}`);
    if (payload?.threshold) qpm.push(`threshold=${payload?.threshold}`);
    if (payload?.sequence_id) qpm.push(`sequence_id=${payload?.sequence_id}`);

    let qpmString = "";
    if (qpm?.length > 0) qpmString = "?" + qpm.join("&");

    const response = await AspApi.get(
        `/api/v1/svc/campaign_sequence/keywords/check_keyword${qpmString}`,
        payload
    );
    return response;
};
